<template>
  <v-container>
    <v-btn color="#4d48f9" style="text-transform: none !important;color:white;" @click="routeHelpMenuContentAdd()">YENİ SORU
      EKLE
    </v-btn>
    <br />
    <br />
    <v-card>
      <v-card-title>
        Sorular
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="contentList"
        :footer-props="{
    'items-per-page-options': [10,25,50,100],
    'disablePagination' : true
  }"
        :items-per-page="10"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >

        <template v-slot:item.active="{ item }">
          <v-checkbox v-model="item.active" color="#4d48f9" @change="helpMenuContentStatusChange(item)"></v-checkbox>
        </template>

        <template v-slot:item.priority="{ item }">
          <v-text-field single-line
                        hide-details
                        flat
                        solo
                        min="0"
                        v-model="item.priority" style="width:70px" color="#4d48f9" type="number"
                        @change="helpMenuContentPriority(item)"></v-text-field>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="routeHelpMenuContentEdit(item)">mdi-pencil</v-icon>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="helpMenuContentData.pageNumber"
          color="#4d48f9"
          :length="pagination.pagesLength"
          @input="setPageNumber"
        ></v-pagination>
      </div>
    </v-card>
  </v-container>
</template>

<script>

import { mapGetters, mapActions } from "vuex";

export default {
  name: "helpMenuContents",
  data: () => ({

    helpMenuContentData: {
      pageNumber: 1,
      pageSize: 10
    },

    pagination: {
      totalItems: 20,
      pagesLength: 0
    },
    headers: [
      { text: "Soru Id", value: "id", align: "start", sortable: false },
      { text: "Kategorı", value: "category", sortable: false },
      { text: "Soru", value: "title", sortable: false },
      { text: "Aktif/Pasif", value: "active", sortable: false },
      { text: "Öncelik", value: "priority", sortable: false },
      { text: "Detay", value: "actions", sortable: false }

    ]
  }),
  computed: mapGetters(["contentList","loading"]),
  created() {
    const page = this.$route.query.page ? this.$route.query.page : 1;
    this.helpMenuContentData.pageNumber = Number(page);
    this.getContentList(this.helpMenuContentData).then(response => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    });
  },
  methods: {
    ...mapActions(["getContentList", "updateContentStatus", "updateContentPriority"]),
    //Data table item per page changed function
    getItemPerPage(val) {
      this.helpMenuContentData.pageSize = val;
      this.helpMenuContentData.pageNumber = 1;
      this.getContentList(this.helpMenuContentData).then((response) => {
        this.pagination.pagesLength = response.totalPages
      })
      console.log(this.helpMenuContentData);
    },
    //Data table page number changed function
    getPageNumber(val) {
      this.helpMenuContentData.pageNumber = val;
      if(val !== 1){
        this.$router.push({ query: { page: val } });
      }
      this.getContentList(this.helpMenuContentData);
    },
    setPageNumber(val) {
      if ((!this.$route.query.page && val == 1) || (this.$route.query.page == val))
        return;
      this.$router.push({ path: this.$route.fullPath, query: { page: val } });
    },
    filterByhelpMenuContentChanged(value) {
      this.helpMenuContentData.filterByhelpMenuContent = value;
      this.helpMenuContentData.pageNumber = 1;
      this.getContentList(this.helpMenuContentData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      });
    },

    //helpMenuContentAdd
    routeHelpMenuContentAdd() {
      this.$router.push("helpMenuContent");
    },
    //helpMenuContentStatus
    helpMenuContentStatusChange(helpMenuContent) {
      this.updateContentStatus(helpMenuContent).then(response => {
        if (response.processStatus == "Success") {
          alert("Güncelleme işlemi başarılıdır");
        } else {
          alert("Bir hata oluştu");
        }
      }).catch(err => {
        alert(err);
      });

    },
    helpMenuContentPriority(helpMenuContent) {
      this.updateContentPriority(helpMenuContent).then(response => {
        if (response.processStatus == "Success") {
          alert("Güncelleme işlemi başarılıdır");
        } else {
          alert("Bir hata oluştu");
        }
      }).catch(err => {
        alert(err);
      });

    },

    routeHelpMenuContentEdit(item) {
      console.log("item", item);
      this.$router.push(`helpMenuContent/${item.id}`);
    },
    redirectLink(endpoint) {
      console.log(endpoint);
      window.open(
        endpoint,
        "_blank" // <- This is what makes it open in a new window.
      );
    },
  },
  watch: {
    '$route'(to) {
      this.processUrlChange(to);
    },
    "$route.query.page"(val) {
      const pageNumber = val ? Number(val) : 1;
      this.getPageNumber(pageNumber);
    },
  }
};
</script>
